import { createContext, useMemo, ReactNode } from 'react';

// project imports
import config, { AppConfig } from 'config';
import { useLocalStorage, UseLocalStorageReturn } from 'hooks/useLocalStorage';

export type ConfigContextValue = UseLocalStorageReturn<AppConfig>;

// ==============================|| CONFIG CONTEXT ||============================== //

export const ConfigContext = createContext<ConfigContextValue | undefined>(undefined);

// ==============================|| CONFIG PROVIDER ||============================== //

export function ConfigProvider({ children }: { children: ReactNode }) {
  const { state, setState, setField, resetState } = useLocalStorage<AppConfig>('mantis-react-free-config', config);

  const memoizedValue = useMemo(() => ({ state, setState, setField, resetState }), [state, setField, setState, resetState]);

  return <ConfigContext.Provider value={memoizedValue}>{children}</ConfigContext.Provider>;
}
